import contextMakePost from './Context';

export const createCreative = async (accountId, parameters) => {
  const id = `act_${accountId}/adcreatives`;
  const result = await contextMakePost(parameters, id);
  return result.json();
};



// WEBPACK FOOTER //
// ./src/fbApi/Creative.js